
import $ from 'jquery';

import 'intersection-observer';

import globals from './global/globals';
import globalelements from './global/elements';
import logger from './logger';


export default function (options) {
    var o = $.extend({
        seekAheadDist: '200%', // only % or px

        lazyImgSelector: '[data-lazy-img]',
        lazyVidSelector: '[data-lazy-vid]',

        imgLoaderClass: 'media__loader',

        devMode: true
    }, options);


    var ele = {
        lazys: $(o.lazyImgSelector + ',' + o.lazyVidSelector),
        lazyImgs: $(o.lazyImgSelector),
        lazyVids: $(o.lazyVidSelector)
    };


    var internal = {
        name: 'LazyLoader',

        pixelRatio: window.devicePixelRatio || 1,

        lazyloadObserver: null
    };


    var fn = {
        init: function () {
            // add loading progress to Image prototype
            fn.setupImageLoadingPrototype();

            // setup observer
            internal.lazyloadObserver = new window.IntersectionObserver(handlers.lazyloadObserverHandler, {
                root: null,
                rootMargin: o.seekAheadDist,
                threshold: 0
            });

            ele.lazyImgs.data('type', 'img');
            ele.lazyVids.data('type', 'vid');

            // observe all initial items on page on load
            fn.observeItems(ele.lazys);

            // handlers
            globalelements.doc.on('lazyloaderNewElementsAdded', handlers.lazyloaderNewElementsAdded);
        },

        setupImageLoadingPrototype: function () {
            Image.prototype.load = function (url) {
                var img = this;
                var $img = $(img);
                var loader = $('<div class="' + o.imgLoaderClass + ' "' + ($img.data('parent-bg') ? 'style="background: ' + $img.data('parent-bg') + '"' : '') + '"></div>');
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'arraybuffer';
                xhr.onload = function (e) {
                    var blob = new Blob([this.response]);
                    img.src = window.URL.createObjectURL(blob);
                    loader.addClass(globals.classes.state.loaded);
                };
                xhr.onprogress = function (e) {
                    // img.completedPercentage = parseInt((e.loaded / e.total) * 100);
                    // loader.css('width', img.completedPercentage + '%');
                };
                xhr.onloadstart = function () {
                    img.completedPercentage = 0;
                    loader.insertAfter($img);
                };
                xhr.send();
            };

            Image.prototype.completedPercentage = 0;
        },

        observeItems: function (items) {
            items.each(function () {
                internal.lazyloadObserver.observe($(this)[0]);
            });
        },

        loadLazy: function (entry) {
            var media = $(entry);

            if (media.data('type') === 'img' && !media.data('loaded')) {
                fn.loadImg(media);
            } else if (media.data('type') === 'vid' && !media.data('playing')) {
                fn.playVid(media);
            }
        },

        loadImg: function (img) {
            var srcSizes, eleNativeWidth, smallestDiff, closestWidth, loader;

            // get the list of resized images and choose the most
            // appropriate one based on the element's size
            srcSizes = img.data('lazy-img');

            eleNativeWidth = img.width() * internal.pixelRatio;

            $.each(srcSizes, function (width, src) {
                width = parseInt(width, 10);

                var diff = Math.abs(eleNativeWidth - width);

                // set the smallest diff the first time...
                // OR override if diff is smaller than last...
                // OR, if the previously saved closest width is smaller
                // than the space for it, bump up to the next biggest size
                if (!smallestDiff || diff < smallestDiff || (closestWidth < eleNativeWidth && width >= eleNativeWidth)) {
                    smallestDiff = diff;
                    closestWidth = width;
                }
            });

            fn.console([
                'element native width: *' + eleNativeWidth.toFixed(2) + 'px*',
                'best available size: *' + closestWidth + 'px*'
            ]);

            // load the image and assign it
            img[0].load(srcSizes[closestWidth], loader);

            img.data('loaded', true);
        },

        playVid: function (video) {
            video[0].play();
            video.data('playing', true);
        },

        console: function (msgs) {
            logger(msgs, {
                enabled: o.devMode,
                prefix: internal.name + '.js',
                prefixColor: 'violet'
            });
        }
    };


    var handlers = {
        resize: function () {
        },
        lazyloadObserverHandler: function (entries) {
            $.each(entries, function (i, entry) {
                if (entry.isIntersecting) {
                    fn.loadLazy(entry.target);
                }
            });
        },
        lazyloaderNewElementsAdded: function (e, d) {
            var newImgs = d.elements.find(o.lazyImgSelector);
            var newVids = d.elements.find(o.lazyVidSelector);

            newImgs.data('type', 'img');
            newVids.data('type', 'vid');

            fn.observeItems(newImgs);
            fn.observeItems(newVids);
        }
    };


    fn.init();
}
